import ContentAutoCreationSection from "components/modules/crm/email-settings/ContentAutoCreationSection";
import SwitchSection from "components/modules/crm/email-settings/SwitchSection";
import VisibilitySection from "components/modules/crm/email-settings/VisibilitySection";
import React from "react";
import { Col, Nav, Row, Tab } from "react-bootstrap";

interface EmailData {
  id: string;
  email: string;
  content: string;
}

const emailsData: EmailData[] = [
  {
    id: "home",
    email: "mastercleaningseo@gmail.com",
    content:
      "Raw denim you probably haven't heard of them jean shorts Austin. Nesciunt tofu stumptown aliqua, retro synth master cleanse. Mustache cliche tempor, williamsburg carles vegan helvetica. Reprehenderit butcher retro keffiyeh dreamcatcher synth.",
  },
  {
    id: "profile",
    email: "stellartalentseo@gmail.com",
    content:
      "Food truck fixie locavore, accusamus mcsweeney's marfa nulla single-origin coffee squid. Exercitation +1 labore velit, blog sartorial PBR leggings next level wes anderson artisan four loko farm-to-table craft beer twee.",
  },
];

const Emails = () => {
  return (
    <Row>
      <Col xl={6} xxl={4}>
        <h3 className="mb-4">Emails</h3>

        <Tab.Container id="email-tabs" defaultActiveKey={emailsData[0].id}>
          <Nav variant="underline" className="mb-5">
            {emailsData.map((item) => (
              <Nav.Item key={item.id}>
                <Nav.Link eventKey={item.id}>{item.email}</Nav.Link>
              </Nav.Item>
            ))}
          </Nav>
          <Tab.Content>
            {emailsData.map((item) => (
              <Tab.Pane key={item.id} eventKey={item.id}>
                <div className="mt-4">
                  <h5>Visibility</h5>
                  <p className="mb-0 fs-9">
                    Define what will be visible to other users in your workspace
                  </p>
                  <VisibilitySection />
                </div>

                <div className="my-4">
                  <h5>Contact auto-creation</h5>
                  <p className="mb-0 fs-9">
                    Automatically create People records when receiving or
                    sending emails
                  </p>
                  <ContentAutoCreationSection />
                </div>
                <div className="mb-4">
                  <SwitchSection />
                </div>
              </Tab.Pane>
            ))}
          </Tab.Content>
        </Tab.Container>
      </Col>
    </Row>
  );
};

export default Emails;
